import SortNumDesc from './SortNumDesc'

export default SortNumDesc
// eslint-disable-next-line import/export
export * from './SortNumDesc'
